import { COLORS } from 'consts/colors'
import styled from 'styled-components'
//primaryExtraDark
export const TrackItemWrapper = styled.div<{
  $selectedBorderColor: string
  $borderSize: number
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;

  /*  box-shadow - won't affect layout */
  box-shadow: inset 0 0 0 ${({ $borderSize }) => $borderSize}px
    ${({ $selectedBorderColor }) => $selectedBorderColor};
`
export const ResizeButton = styled.div<{
  $side: 'left' | 'right'
  $disabled?: boolean
}>`
  height: 100%;
  width: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  background-color: ${COLORS.primaryExtraDark};
  z-index: 1;
  user-select: none;
  cursor: ${({ $disabled }) => ($disabled ? 'pointer' : 'ew-resize')};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};

  ${({ $side }) =>
    $side === 'left'
      ? `
        left: 0;
        border-radius: 4px 0 0 4px;
      `
      : `
        right: 0;
        border-radius: 0 4px 4px 0;
      `}
`

export const ResizeButtonLine = styled.div`
  width: 3px;
  height: 60%;
  max-height: 30px;
  border-radius: 2px;
  background-color: ${COLORS.white};
`
